import React from 'react';
import Challenge3dsModalRenderer from '@src/features/payments/external-auth/components/Challenge3dsModalRenderer';
import { ExternalAuthenticationProviderType, type PaymentOption } from '@src/domains/payments';
import { useAppSelector } from '@src/core/hooks';
import { externalAuthenticationSelector } from '@src/features/payments/store/payment';

type ExternalAuthenticationSetupProps = {
  paymentOption: PaymentOption;
};

const ExternalAuthenticationSetup = (props: ExternalAuthenticationSetupProps) => {
  const { paymentOption } = props;
  const externalAuthentication = useAppSelector(externalAuthenticationSelector);

  if (!paymentOption || !paymentOption.requiresExternalAuthentication) {
    return null;
  }

  // The authentication in course picks its modal. Before one starts, Pagar.me's stays mounted: its provider
  // looks its container up as soon as it starts, in the same tick the store learns the type, before React
  // has rendered. It is hidden until Pagar.me injects its frame.
  const provider = externalAuthentication?.type ?? ExternalAuthenticationProviderType.Pgmpi;

  return <Challenge3dsModalRenderer provider={provider} />;
};

export default ExternalAuthenticationSetup;
